import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
    @Input() title: string;
    @Input() description: string;
    @Input() status: 'success' | 'warning' | 'danger';
    @Input() buttonText: string;
    @Input() confirm: () => void;

    constructor(private dialogRef: NbDialogRef<ConfirmationDialogComponent>) {}

    close() {
        this.dialogRef.close();
    }

    get statusClass() {
        switch (this.status) {
            case 'success':
                return 'container-success';
            case 'warning':
                return 'container-warning';
            case 'danger':
                return 'container-danger';
            default:
                return '';
        }
    }
}
